import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../../pipes/pipes.module';
import { LoaderButtonModule } from '../loader-button/loader-button.module';
import { RouterModule } from '@angular/router';
import { RentPaymentAddComponent } from './rent-payment-add-form.component';
import { TextboxModule } from '../textbox/textbox.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { SwitchModule } from '../switch/switch.module';
import { DateTimePickerModule } from '../date-time-picker/date-time-picker.module';
import { RichTextEditorModule } from '../rich-text-editor/rich-text-editor.module';
import { LoadingIndicatorModule } from '../loading-indicator/loading-indicator.module';
import { ErrorSummaryModule } from '../error-summary/error-summary.module';
import { AccordionModule } from '../accordion/accordion.module';
import { RentPaymentAssociationModule } from '../rent-payment-association-selector/rent-payment-association-selector.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { SearchableDropdownModule } from '../searchable-dropdown/searchable-dropdown.module';
import {ErrorResponseSummaryModule} from "../error-response-summary/error-response-summary.module";
import {FormMessageModule} from "../form-message/form-message.module";
import {RadioModule} from "../radio/radio.module";
import {RadioButtonModule} from "../radio-button/radio-button.module";
import {TransactionRuleFormComponent} from '../transaction-rules/transaction-rule-form.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        PipesModule,
        TextboxModule,
        DropdownModule,
        SwitchModule,
        DateTimePickerModule,
        RichTextEditorModule,
        LoadingIndicatorModule,
        PipesModule,
        LoadingIndicatorModule,
        LoaderButtonModule,
        ErrorSummaryModule,
        AccordionModule,
        RentPaymentAssociationModule,
        CheckboxModule,
        SearchableDropdownModule,
        ErrorResponseSummaryModule,
        FormMessageModule,
        RadioModule,
        RadioButtonModule,
        TransactionRuleFormComponent

    ],
    declarations: [
        RentPaymentAddComponent
    ],
    exports: [
        RentPaymentAddComponent
    ]
})

export class RentPaymentAddFormModule {
}
